import { contactUs } from "../../constants/data";
import Content from "../../components/Content";
import { PageType } from "../../app/types/general";

const ContactUs = () => {
  return (
    <Content
      title="Contact Us"
      subtitles={[
        "We would love to hear any feedback and/or thoughts",
      ]}
      activePage={PageType.CONTACT}
      textData={contactUs}
    />
  );
};

export default ContactUs;